// import Client from 'shopify-buy';
import Client from 'shopify-buy/index.unoptimized.umd';

export default Client.buildClient({
    domain: 'storror.myshopify.com',
    storefrontAccessToken: '547c8444445fe30f6f4a80a6aa7b7b44',
});
